import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_WellnessAssessmentYouth = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_WellnessAssessmentYouth' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><span className='eleHeader'>Wellness Assessment - Adult</span></p>

                <p>
                    Completing this brief questionnaire will help us provide services that meet your child's needs. Answer each
                    question as best you can and then review your responses with your child's clinician. Shade circles like this
                </p>

                <table>
                    <tr>
                        <td>
                            <span><b>Visit #: </b></span>
                            <input type='radio' id='rbVisit1' name='rbVisit' className='add-only' value='1 or 2' /> 1 or 2 &nbsp;
                            <input type='radio' id='rbVisit3' name='rbVisit' className='add-only' value='3 to 5' /> 3 to 5 &nbsp;
                            <input type='radio' id='rbOther' name='rbVisit' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span><b>Relationship to child: </b></span>
                            <input type='radio' id='rbMother' name='rbRelationshipToChild' className='add-only' value='Mother' /> Mother &nbsp;
                            <input type='radio' id='rbFather' name='rbRelationshipToChild' className='add-only' value='Father' /> Father &nbsp;
                            <input type='radio' id='rbStepparent' name='rbRelationshipToChild' className='add-only' value='Stepparent' /> Stepparent &nbsp;
                            <input type='radio' id='rbOtherRelative' name='rbRelationshipToChild' className='add-only' value='Other Relative' /> Other Relative &nbsp;
                            <input type='radio' id='rbChildSelf' name='rbRelationshipToChild' className='add-only' value='Child/Self' /> Child/Self &nbsp;
                            <input type='radio' id='rbOther1' name='rbRelationshipToChild' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>For questions 1-21, please think about your experience in the past week.</h3></p>

                <table>
                    <tr>
                        <td className='w-360'><span className='eleHeader'>Fill in the circle that best describes your child:</span></td>
                        <td className='w-130'><span className='eleHeader'>Never</span></td>
                        <td className='w-130'><span className='eleHeader'>Sometimes</span></td>
                        <td className='w-130'><span className='eleHeader'>Often</span></td>
                    </tr>
                    <tr>
                        <td className='w-360'>1. Destroyed property</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_1' name='rbDestroyedProperty' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_1' name='rbDestroyedProperty' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_1' name='rbDestroyedProperty' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>2. Was unhappy or sad</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_2' name='rbUnhappyOrSad' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_2' name='rbUnhappyOrSad' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_2' name='rbUnhappyOrSad' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>3. Behavior caused school problems</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_3' name='rbSchoolProblems' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_3' name='rbSchoolProblems' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_3' name='rbSchoolProblems' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>4. Had temper outbursts</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_4' name='rbTemperOutbursts' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_4' name='rbTemperOutbursts' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_4' name='rbTemperOutbursts' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>5. Worrying prevented him/her from doing things</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_5' name='rbWorryingPrevented' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_5' name='rbWorryingPrevented' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_5' name='rbWorryingPrevented' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>6. Felt worthless or inferior</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_6' name='rbFeltWorthless' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_6' name='rbFeltWorthless' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_6' name='rbFeltWorthless' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>7. Had trouble sleeping</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_7' name='rbTroubleSleeping' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_7' name='rbTroubleSleeping' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_7' name='rbTroubleSleeping' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>8. Changed moods quickly</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_8' name='rbChangedMoodsQuickly' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_8' name='rbChangedMoodsQuickly' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_8' name='rbChangedMoodsQuickly' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>9. Used alcohol</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_9' name='rbUsedAlcohol' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_9' name='rbUsedAlcohol' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_9' name='rbUsedAlcohol' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>10. Was restless, trouble staying seated</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_10' name='rbRestless' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_10' name='rbRestless' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_10' name='rbRestless' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>11. Engaged in repetitious behavior</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_11' name='rbRepetitiousBehavior' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_11' name='rbRepetitiousBehavior' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_11' name='rbRepetitiousBehavior' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>12. Used drugs</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_12' name='rbUsedDrugs' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_12' name='rbUsedDrugs' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_12' name='rbUsedDrugs' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>13. Worried about most everything</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_13' name='rbWorriedAboutMostEverything' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_13' name='rbWorriedAboutMostEverything' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_13' name='rbWorriedAboutMostEverything' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>14. Needed constant attention</td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbNever_14' name='rbNeededConstantAttention' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbSometimes_14' name='rbNeededConstantAttention' className='add-only' value='Sometimes' /></center>
                        </td>
                        <td className='w-130'>
                            <center><input type='radio' id='rbOften_14' name='rbNeededConstantAttention' className='add-only' value='Often' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>How much have your child's problems caused:</span></td>
                        <td className='w-100'><span className='eleHeader'>Not at All</span></td>
                        <td className='w-100'><span className='eleHeader'>A Little</span></td>
                        <td className='w-100'><span className='eleHeader'>Somewhat</span></td>
                        <td className='w-100'><span className='eleHeader'>A Lot</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>15. Interruption of personal time?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_1' name='rbInterruptionOfPersonalTime' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_1' name='rbInterruptionOfPersonalTime' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_1' name='rbInterruptionOfPersonalTime' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_1' name='rbInterruptionOfPersonalTime' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>16. Disruption of family routines?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_2' name='rbFamilyRoutines' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_2' name='rbFamilyRoutines' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_2' name='rbFamilyRoutines' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_2' name='rbFamilyRoutines' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>17. Any family member to suffer mental or physical problems?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_3' name='rbPhysicalProblems' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_3' name='rbPhysicalProblems' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_3' name='rbPhysicalProblems' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_3' name='rbPhysicalProblems' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>18. Less attention paid to any family member?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_4' name='rbFamilyMember' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_4' name='rbFamilyMember' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_4' name='rbFamilyMember' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_4' name='rbFamilyMember' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>19. Disruption or upset of relationships within the family?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_5' name='rbDisruptionOrUpsetOfRelationships' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_5' name='rbDisruptionOrUpsetOfRelationships' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_5' name='rbDisruptionOrUpsetOfRelationships' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_5' name='rbDisruptionOrUpsetOfRelationships' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>20. Disruption or upset of your family's social activities?</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_6' name='rbSocialActivities' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_6' name='rbSocialActivities' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_6' name='rbSocialActivities' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_6' name='rbSocialActivities' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            21. How many days in the past week was your child's usual routine interrupted by their problems?
                            <input type='text' id='txtUsualRoutineInterrupted' name='txtUsualRoutineInterrupted' className='add-only w-250 custom-add-only' /> Days
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td><b>Answer the following only if this is your first time completing this questionnaire for this child.</b></td>
                    </tr>
                    <tr>
                        <td>
                            22. In general, would you say your child's health is: <br />
                            <input type='radio' id='rbExcellent' name='rbChildHealth' className='add-only' value='Excellent' /> Excellent &nbsp;
                            <input type='radio' id='rbVeryGood' name='rbChildHealth' className='add-only' value='Very Good' /> Very Good &nbsp;
                            <input type='radio' id='rbGood' name='rbChildHealth' className='add-only' value='Good' /> Good &nbsp;
                            <input type='radio' id='rbFair' name='rbChildHealth' className='add-only' value='Fair' /> Fair &nbsp;
                            <input type='radio' id='rbPoor' name='rbChildHealth' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td>
                            23. In the past 6 months, how many times did your child visit a medical doctor? <br />
                            <input type='radio' id='rbMedicalDoctor_1' name='rbMedicalDoctor' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbMedicalDoctor_2' name='rbMedicalDoctor' className='add-only' value='1' /> 1 &nbsp;
                            <input type='radio' id='rbMedicalDoctor_3' name='rbMedicalDoctor' className='add-only' value='2-3' /> 2-3 &nbsp;
                            <input type='radio' id='rbMedicalDoctor_4' name='rbMedicalDoctor' className='add-only' value='4-5' /> 4-5 &nbsp;
                            <input type='radio' id='rbMedicalDoctor_5' name='rbMedicalDoctor' className='add-only' value='6+' /> 6+
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td>
                            24. In past month, how many days were you unable to work because of your child's problems? (answer only if employed) &nbsp;
                            <input type='text' id='txtChildsProblems' name='txtChildsProblems' className='add-only w-250 custom-add-only' /> Days
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td>
                            25. In the past month, how many days were you able to work but had to cut back on
                                how much you got done because of your child's problems? (answer only if employed) &nbsp;
                            <input type='text' id='txtYourChildsProblems' name='txtYourChildsProblems' className='add-only w-250 custom-add-only' /> Days
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











